import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { cond, isEmpty, always, either, isNil, defaultTo } from 'ramda'
import withFieldError from 'components/form/with-error'

export const FacebookReactionOn = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <input
    {...input}
    className={'form-control ' + (error && touched ? 'has-error' : '')}
    type='text'
    placeholder='Enter post ID'
    defaultValue={value}
  />
)

FacebookReactionOn.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const FacebookReactionOnWithError = withFieldError(FacebookReactionOn)

export const validate = cond([
  [either(isEmpty, isNil), always('Please enter a Post ID')]
])

const FacebookReactionOnField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={FacebookReactionOnWithError}
      validate={validate}
      format={defaultTo([])}
    />
  </div>
)

FacebookReactionOnField.propTypes = {
  name: PropTypes.string
}

export default FacebookReactionOnField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/facebook/reaction-on/index.js